import axios from 'axios';
;
export const http = async ({ endpoint, method = 'GET', data = undefined }) => {
    const result = await axios({
        method,
        url: 'https://aj-api.herokuapp.com' + endpoint,
        data,
    });
    return result.data;
};
